import { isAfter, isEqual, isBefore, startOfDay } from 'date-fns';
export * from 'date-fns';
export const isAfterOrEqual = (firstDate, secondDate) => {
  return isAfter(firstDate, secondDate) || isEqual(firstDate, secondDate);
};
export const isBeforeOrEqual = (firstDate, secondDate) => {
  return isBefore(firstDate, secondDate) || isEqual(firstDate, secondDate);
};
export const isFutureOrToday = (firstDate, secondDate) => {
  const firstDateStartOfDay = startOfDay(firstDate);
  const secondDateStartOfDay = startOfDay(secondDate);
  return isAfterOrEqual(firstDateStartOfDay, secondDateStartOfDay);
};
export const isPastOrToday = (firstDate, secondDate) => {
  const firstDateStartOfDay = startOfDay(firstDate);
  const secondDateStartOfDay = startOfDay(secondDate);
  return isBeforeOrEqual(firstDateStartOfDay, secondDateStartOfDay);
};